<template>
  <div class="content-dashboard">
    <div class="d-flex align-items-center justify-content-between">
      <h3>Mes factures</h3>
      <!-- <a href="#" class="btn btn-orange font-bold" @click.prevent="downloadAll">
        <i class="ti ti-download"></i> Télécharger
      </a> -->
    </div>

    <!-- <h4 class="mt-4 mb-4 font-15">{{ factureStore.TotalItems || 0 }} factures</h4> -->

    <div class="mt-3 d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
      <div class="d-flex gap-3 align-items-center flex-wrap">
        <!-- Tri Date de commande -->
        <a
          href="#"
          class="btn btn-outline-orange"
          :class="{ 'btn-orange': factureStore.sortBy === 'Par_PiDt' || factureStore.sortBy === 'Par_PiDt_Desc' }"
          @click.prevent="factureStore.changeSort(factureStore.sortBy === 'Par_PiDt' ? 'Par_PiDt_Desc' : 'Par_PiDt')"
        >
          <i
            class="ti ti-calendar orange-color pe-2"
            :class="{ 'icon-white': factureStore.sortBy === 'Par_PiDt' || factureStore.sortBy === 'Par_PiDt_Desc' }"
          ></i>
          Date de commande
          <i
            class="ti"
            :class="{
              'ti-arrow-up': factureStore.sortBy === 'Par_PiDt',
              'ti-arrow-down': factureStore.sortBy === 'Par_PiDt_Desc',
              'icon-white': factureStore.sortBy === 'Par_PiDt' || factureStore.sortBy === 'Par_PiDt_Desc',
            }"
          ></i>
        </a>

        <!-- Tri Montant -->
        <a
          href="#"
          class="btn btn-outline-orange"
          :class="{ 'btn-orange': factureStore.sortBy === 'Par_HtMt' || factureStore.sortBy === 'Par_HtMt_Desc' }"
          @click.prevent="factureStore.changeSort(factureStore.sortBy === 'Par_HtMt' ? 'Par_HtMt_Desc' : 'Par_HtMt')"
        >
          <i
            class="ti ti-receipt orange-color pe-2"
            :class="{ 'icon-white': factureStore.sortBy === 'Par_HtMt' || factureStore.sortBy === 'Par_HtMt_Desc' }"
          ></i>
          Montant
          <i
            class="ti"
            :class="{
              'ti-arrow-up': factureStore.sortBy === 'Par_HtMt',
              'ti-arrow-down': factureStore.sortBy === 'Par_HtMt_Desc',
              'icon-white': factureStore.sortBy === 'Par_HtMt' || factureStore.sortBy === 'Par_HtMt_Desc',
            }"
          ></i>
        </a>

        <!-- Filtre Facture / Récapitulatif (à côté de Montant) -->
        <div class="custom-filter-dropdown" ref="dropdownRef">
          <button
            type="button"
            class="btn btn-outline-orange filter-btn d-flex align-items-center justify-content-between gap-3"
            @click="isOpen = !isOpen"
          >
            <span>{{ selectedLabel }}</span>
            <i class="ti ti-angle-down chevron-icon" :class="{ rotated: isOpen }"></i>
          </button>
          <div v-if="isOpen" class="dropdown-list">
            <div
              class="dropdown-option"
              :class="{ selected: factureStore.typeFilter === 'all' }"
              @click="selectType('all')"
            >
              Toutes
            </div>
            <div
              class="dropdown-option"
              :class="{ selected: factureStore.typeFilter === 'facture' }"
              @click="selectType('facture')"
            >
              Factures
            </div>
            <div
              class="dropdown-option"
              :class="{ selected: factureStore.typeFilter === 'recap' }"
              @click="selectType('recap')"
            >
              Récapitulatifs
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mb-3">
        <button class="btn-view me-2" :class="{ active: view === 'grid' }" @click="view = 'grid'">
          <i class="ti ti-layout-grid2"></i>
        </button>
        <button class="btn-view" :class="{ active: view === 'list' }" @click="view = 'list'">
          <i class="ti ti-menu"></i>
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="factureStore.getIsLoading" class="text-center py-3">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-3">
        {{ factureStore.typeFilter === "recap" ? "Chargement des récapitulatifs..." : "Chargement des factures..." }}
      </p>
    </div>
    <!-- No Invoices -->
    <div v-else-if="!factureStore.getFactures.length" class="alert alert-info">
      {{
        factureStore.typeFilter === "recap"
          ? "Aucun récapitulatif trouvé."
          : factureStore.typeFilter === "facture"
            ? "Aucune facture trouvée."
            : "Aucun document trouvé."
      }}
    </div>

    <!-- Grid View -->
    <div v-else-if="view === 'grid'" class="row">
      <template v-for="item in factureStore.getFactures" :key="item.PINO">
        <!-- Bloc Récapitulatif (si OP = CW4 ET filtre != 'facture') -->
        <div v-if="isRecap(item) && factureStore.typeFilter !== 'facture'" class="col-lg-4">
          <div class="gray-box d-block facture-box">
            <p class="mb-1 dark-color font-15">{{ formatDate(item.PiDt) }}</p>
            <div class="d-flex gap-2 align-items-center mb-2">
              <i class="ti ti-receipt blue-color font-30"></i>
              <div class="gray-box-info">
                <p class="font-bold mb-0">Récapitulatif N° {{ item.PINO }}</p>
                <span class="font-bold">{{ formatPrice(item.TTCMT) }}€ TTC</span>
              </div>
            </div>
            <a
              href="#"
              class="btn btn-outline-orange"
              :class="{ disabled: downloading[item.PINO + '_recap'] }"
              @click.prevent="downloadFacture(item.PINO, item.PREFPINO, true, item.PINO + '_recap')"
            >
              <i v-if="downloading[item.PINO + '_recap']" class="ti ti-loader pe-2 spinning me-2"></i>
              <i v-else class="ti ti-download pe-2"></i>
              <span>Télécharger</span>
            </a>
          </div>
        </div>

        <!-- Bloc Facture (caché si filtre = 'recap') -->
        <div v-if="factureStore.typeFilter !== 'recap'" class="col-lg-4">
          <div class="gray-box d-block facture-box">
            <p class="mb-1 dark-color font-15">{{ formatDate(item.PiDt) }}</p>
            <div class="d-flex gap-2 align-items-center mb-2">
              <i class="ti ti-receipt blue-color font-30"></i>
              <div class="gray-box-info">
                <p class="font-bold mb-0">Facture N° {{ item.PINO }}</p>
                <span class="font-bold">{{ formatPrice(item.TTCMT) }}€ TTC</span>
              </div>
            </div>
            <a
              href="#"
              class="btn btn-outline-orange"
              :class="{ disabled: downloading[item.PINO + '_facture'] }"
              @click.prevent="downloadFacture(item.PINO, item.PREFPINO, false, item.PINO + '_facture')"
            >
              <i v-if="downloading[item.PINO + '_facture']" class="ti ti-loader pe-2 spinning me-2"></i>
              <i v-else class="ti ti-download pe-2"></i>
              <span>Télécharger</span>
            </a>
          </div>
        </div>
      </template>
    </div>

    <!-- List View -->
    <div v-else>
      <template v-for="item in factureStore.getFactures" :key="item.PINO">
        <!-- Bloc Récapitulatif (si OP = CW4 ET filtre != 'facture') -->
        <div v-if="isRecap(item) && factureStore.typeFilter !== 'facture'" class="gray-box d-block facture-box">
          <div class="row g-0 align-items-center justify-content-between">
            <div class="col-md-8">
              <p class="mb-1 dark-color font-15">{{ formatDate(item.PiDt) }}</p>
              <div class="d-flex gap-2 align-items-center mb-2">
                <i class="ti ti-receipt blue-color font-30"></i>
                <div class="gray-box-info">
                  <p class="font-bold mb-0">Récapitulatif N° {{ item.PINO }}</p>
                  <span class="font-bold">{{ formatPrice(item.TTCMT) }}€ TTC</span>
                </div>
              </div>
            </div>
            <div class="col-md-4 text-right">
              <a
                href="#"
                class="btn btn-outline-orange"
                :class="{ disabled: downloading[item.PINO + '_recap'] }"
                @click.prevent="downloadFacture(item.PINO, item.PREFPINO, true, item.PINO + '_recap')"
              >
                <i v-if="downloading[item.PINO + '_recap']" class="ti ti-loader pe-2 spinning me-2"></i>
                <i v-else class="ti ti-download pe-2"></i>
                <span>Télécharger</span>
              </a>
            </div>
          </div>
        </div>

        <!-- Bloc Facture (caché si filtre = 'recap') -->
        <div v-if="factureStore.typeFilter !== 'recap'" class="gray-box d-block facture-box">
          <div class="row g-0 align-items-center justify-content-between">
            <div class="col-md-8">
              <p class="mb-1 dark-color font-15">{{ formatDate(item.PiDt) }}</p>
              <div class="d-flex gap-2 align-items-center mb-2">
                <i class="ti ti-receipt blue-color font-30"></i>
                <div class="gray-box-info">
                  <p class="font-bold mb-0">Facture N° {{ item.PINO }}</p>
                  <span class="font-bold">{{ formatPrice(item.TTCMT) }}€ TTC</span>
                </div>
              </div>
            </div>
            <div class="col-md-4 text-right">
              <a
                href="#"
                class="btn btn-outline-orange"
                :class="{ disabled: downloading[item.PINO + '_facture'] }"
                @click.prevent="downloadFacture(item.PINO, item.PREFPINO, false, item.PINO + '_facture')"
              >
                <i v-if="downloading[item.PINO + '_facture']" class="ti ti-loader pe-2 spinning me-2"></i>
                <i v-else class="ti ti-download pe-2"></i>
                <span>Télécharger</span>
              </a>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- Pagination -->
    <div
      v-if="factureStore.getFactures.length"
      class="pagination mt-4 d-flex justify-content-center align-items-center"
    >
      <button
        @click="factureStore.changePage(factureStore.getCurrentPage - 1)"
        :disabled="factureStore.getCurrentPage === 1"
        class="pagination-btn prev"
      >
        <i class="ti ti-angle-left"></i>
        <span>Précédent</span>
      </button>
      <div class="pagination-content">
        <div class="pagination-btns mt-1">
          <button :class="['pagination-btn-numbers', 'mx-1', { active: true }]">
            {{ factureStore.getCurrentPage }}
          </button>
        </div>
        <span class="pagination-info"></span>
      </div>
      <button
        @click="factureStore.changePage(factureStore.getCurrentPage + 1)"
        :disabled="!factureStore.getHasMorePages"
        class="pagination-btn next"
      >
        <span>Suivant</span>
        <i class="ti ti-angle-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, onBeforeUnmount, computed } from "vue";
  import { useFactureStore } from "@/stores/factureStore";
  import { useToast } from "vue-toastification";

  export default {
    name: "FacturesView",
    setup() {
      const factureStore = useFactureStore();
      const view = ref("grid");
      const downloading = ref({});
      const toast = useToast();
      const isOpen = ref(false);
      const dropdownRef = ref(null);

      const handleClickOutside = event => {
        if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
          isOpen.value = false;
        }
      };

      onMounted(() => {
        document.addEventListener("click", handleClickOutside);
      });

      onBeforeUnmount(() => {
        document.removeEventListener("click", handleClickOutside);
      });

      const selectedLabel = computed(() => {
        switch (factureStore.typeFilter) {
          case "facture":
            return "Factures";
          case "recap":
            return "Récapitulatifs";
          case "all":
          default:
            return "Toutes";
        }
      });

      const selectType = type => {
        isOpen.value = false;
        factureStore.changeTypeFilter(type);
      };

      return {
        factureStore,
        view,
        downloading,
        toast,
        isOpen,
        dropdownRef,
        selectedLabel,
        selectType,
      };
    },
    methods: {
      isRecap(item) {
        return item?.OP === "CW4";
      },
      formatDate(date) {
        if (!date) return "--";
        try {
          // Parse YYYYMMDDHHMMSS format
          const year = date.substring(0, 4);
          const month = date.substring(4, 6);
          const day = date.substring(6, 8);
          const parsedDate = new Date(`${year}-${month}-${day}`);
          if (isNaN(parsedDate)) return "--";
          return parsedDate.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          });
        } catch (error) {
          console.error("Erreur lors du formatage de la date:", error);
          return "--";
        }
      },
      formatPrice(amount) {
        if (!amount && amount !== 0) return "0.00";
        return parseFloat(amount).toFixed(2);
      },
      async downloadFacture(pino, prefPino, isRecap = false, downloadKey = null) {
        const key = downloadKey || pino;
        this.downloading[key] = true;
        try {
          await this.factureStore.downloadFacture(pino, prefPino, isRecap);
        } catch (error) {
          this.toast.error(
            isRecap
              ? "Erreur lors du téléchargement du récapitulatif"
              : "Erreur lors du téléchargement de la facture"
          );
        } finally {
          this.downloading[key] = false;
        }
      },
      downloadAll() {
        console.log("Téléchargement de toutes les factures (à implémenter)");
      },
    },
    mounted() {
      this.factureStore.fetchFactures();
    },
  };
</script>

<style scoped>
  .loading {
    text-align: center;
    padding: 20px;
    font-size: 16px;
    color: #666;
  }
  .facture-box {
    padding: 19px !important;
  }
  .alert-info {
    text-align: center;
    padding: 20px;
    font-size: 16px;
    color: #1e347d;
    background-color: #1e347d12;
    border: 1px solid #1e347d0a;
    border-radius: 4px;
  }
  .btn-outline-orange:hover {
    .orange-color {
      color: white !important;
    }
  }
  .btn-orange {
    color: white !important;
  }
  .icon-white {
    color: white !important;
  }
  .spinning {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid white;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .pagination-btn {
    border-radius: 10px;
    width: max-content;
    height: max-content;
  }
  .custom-filter-dropdown {
    position: relative;
    display: inline-block;
  }
  .filter-btn {
    min-width: 170px;
    background-color: transparent;
    cursor: pointer;
    line-height: 1.5;
  }
  .filter-btn .chevron-icon {
    font-size: 13px;
    color: var(--orange, #ec621a);
    transition: transform 0.2s ease;
  }
  .filter-btn:hover .chevron-icon {
    color: white !important;
  }
  .filter-btn .chevron-icon.rotated {
    transform: rotate(180deg);
  }
  .dropdown-list {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    min-width: 100%;
    width: max-content;
    background: #ffffff;
    border: 1px solid #ffd8c2;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(236, 98, 26, 0.12);
    z-index: 100;
    overflow: hidden;
    padding: 6px;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .dropdown-option {
    padding: 10px 18px;
    font-size: 15px;
    font-weight: 600;
    color: #2c3e50;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.15s ease;
  }
  .dropdown-option:hover {
    background-color: #fff3eb;
    color: var(--orange, #ec621a);
  }
  .dropdown-option.selected {
    background-color: var(--orange, #ec621a);
    color: #ffffff;
  }
</style>
